{
  "name": "@parcel/package-manager",
  "version": "2.12.0",
  "description": "Blazing fast, zero configuration web application bundler",
  "license": "MIT",
  "publishConfig": {
    "access": "public"
  },
  "funding": {
    "type": "opencollective",
    "url": "https://opencollective.com/parcel"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/parcel-bundler/parcel.git"
  },
  "main": "lib/index.js",
  "source": "src/index.js",
  "types": "index.d.ts",
  "engines": {
    "node": ">= 12.0.0"
  },
  "scripts": {
    "build-ts": "mkdir -p lib && flow-to-ts src/types.js > lib/types.d.ts",
    "check-ts": "tsc --noEmit index.d.ts",
    "test": "mocha test"
  },
  "targets": {
    "types": false,
    "main": {
      "includeNodeModules": {
        "@parcel/core": false,
        "@parcel/diagnostic": false,
        "@parcel/fs": false,
        "@parcel/logger": false,
        "@parcel/node-resolver-core": false,
        "@parcel/types": false,
        "@parcel/utils": false,
        "@parcel/workers": false,
        "@swc/core": false,
        "semver": false
      }
    }
  },
  "dependencies": {
    "@parcel/diagnostic": "2.12.0",
    "@parcel/fs": "2.12.0",
    "@parcel/logger": "2.12.0",
    "@parcel/node-resolver-core": "3.3.0",
    "@parcel/types": "2.12.0",
    "@parcel/utils": "2.12.0",
    "@parcel/workers": "2.12.0",
    "@swc/core": "^1.3.36",
    "semver": "^7.5.2"
  },
  "devDependencies": {
    "command-exists": "^1.2.6",
    "cross-spawn": "^6.0.4",
    "nullthrows": "^1.1.1",
    "split2": "^3.1.1"
  },
  "peerDependencies": {
    "@parcel/core": "^2.12.0"
  },
  "browser": {
    "./src/NodePackageManager.js": false,
    "./src/Npm.js": false,
    "./src/Pnpm.js": false,
    "./src/Yarn.js": false
  },
  "gitHead": "2059029ee91e5f03a273b0954d3e629d7375f986"
}
